import styled from 'styled-components';
import { colors } from '@styles/theme';
import { border, space, layout, color } from 'styled-system';

const Dot = styled('div')(
  {
    borderRadius: '50%',
    backgroundColor: colors.grayscale.stone,
    width: '18px',
    height: '18px'
  },
  border,
  space,
  layout,
  color
);

Dot.displayName = 'Dot';

export default Dot;
